import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Stack } from '@mui/material';

interface StackedButtonOptionsProps {
    cancelAction?: {
        label?: string;
        onSelect: () => void;
    };
    onSelect: (selectedItem: any) => void;
    options?: {
        isPrimary?: boolean;
        isSelected?: boolean;
        icon?: IconDefinition;
        label: string;
        value: any;
        href?: string;
    }[];
}

function StackedButtonOptions(props: StackedButtonOptionsProps) {
    const { cancelAction, onSelect = () => {}, options = [] } = props;

    return (
        <Stack sx={{ gap: 2, width: '100%' }}>
            {options?.map((option) => (
                <Button
                    color="primary"
                    disableElevation
                    fullWidth
                    href={option.href}
                    key={option.label}
                    onClick={() => onSelect(option.value)}
                    variant={option.isPrimary ? 'contained' : 'outlined'}
                    startIcon={option.icon ? <FontAwesomeIcon icon={option.icon} /> : undefined}
                    endIcon={option.isSelected ? <FontAwesomeIcon icon={faCheck} /> : undefined}
                    sx={{ '& .MuiButton-endIcon svg': { height: '1rem' } }}
                >
                    {option.label}
                </Button>
            ))}
            {cancelAction && (
                <Button color="primary" disableElevation fullWidth onClick={cancelAction.onSelect}>
                    {cancelAction.label || 'Cancel'}
                </Button>
            )}
        </Stack>
    );
}

export default StackedButtonOptions;
